import React, { useState, useEffect } from "react";
import {
  Grid,
  DialogContent,
  TextField,
  Divider,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  bold: {
    fontWeight: "bold",
  },
}));

function SelectConNote(props) {
  const { conNoteList, selectedList, setSelectedList } = props;
  const [filterExpression, setFilterExpression] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    const reg = new RegExp(filterExpression.toLowerCase());
    const conNoteListExclSelected = conNoteList.filter(
      (e) => !selectedList.includes(e)
    );
    setFilteredList(
      conNoteListExclSelected.filter((conNote) =>
        reg.test(conNote.conNoteNum.toLowerCase())
      )
    );
  }, [filterExpression, conNoteList, selectedList]);

  const handleAdd = (conNote) => {
    // delete
    setFilteredList(filteredList.filter((e) => e !== conNote));
    // add
    if (!selectedList.includes(conNote)) {
      setSelectedList([conNote, ...selectedList]);
    }
  };

  const handleRemove = (conNote) => {
    // delete
    setSelectedList(selectedList.filter((e) => e !== conNote));
    // add
    if (!filteredList.includes(conNote)) {
      setFilteredList([conNote, ...filteredList]);
    }
  };

  //order conNotes by time
  const sortTime = (a, b) =>
    new Date(a.eventDateTime) - new Date(b.eventDateTime);
  const sortedFilteredList = filteredList.sort(sortTime);
  const sortedSelectedList = selectedList.sort(sortTime);

  return (
    <DialogContent>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="filter"
            placeholder="Search Con-Notes..."
            variant="outlined"
            value={filterExpression}
            onChange={(event) => setFilterExpression(event.target.value)}
          />
        </Grid>

        <Grid item sm={6}>
          <Box border={1} borderRadius={4} borderColor="primary.main">
            <ListItem>
              <ListItemText className={classes.bold}>Available</ListItemText>
            </ListItem>

            <ListItem>
              <ListItemText className={classes.bold}>Connote num</ListItemText>
              <ListItemText className={classes.bold}>Type</ListItemText>
              <ListItemText className={classes.bold}>Time</ListItemText>
            </ListItem>
            <Divider />
            <List>
              {filteredList.length === 0 && (
                <ListItem>
                  <ListItemText>No Results...</ListItemText>
                </ListItem>
              )}

              {sortedFilteredList.map((conNote) => (
                <ListItem
                  button
                  key={conNote.dpcId}
                  name={conNote.conNoteNum}
                  onClick={() => handleAdd(conNote)}
                >
                  <ListItemText>{conNote.conNoteNum}</ListItemText>
                  <ListItemText>{conNote.eventType}</ListItemText>
                  <ListItemText>
                    {conNote.eventDateTime.match(/T(\d{2}:\d{2}):/)[1]}
                  </ListItemText>
                </ListItem>
              ))}
            </List>
          </Box>
        </Grid>

        <Grid item sm={6}>
          <Box
            border={1}
            borderRadius={4}
            borderColor={
              selectedList.length > 0 ? "primary.main" : "error.main"
            }
          >
            <ListItem>
              <ListItemText className={classes.bold}>Selected</ListItemText>
            </ListItem>

            <ListItem>
              <ListItemText className={classes.bold}>Connote num</ListItemText>
              <ListItemText className={classes.bold}>Type</ListItemText>
              <ListItemText className={classes.bold}>Time</ListItemText>
            </ListItem>
            <Divider />
            <List>
              {selectedList.length === 0 && (
                <ListItem>
                  <ListItemText>Select at least one Con-Note</ListItemText>
                </ListItem>
              )}
              {sortedSelectedList.map((conNote) => (
                <ListItem
                  button
                  key={conNote.dpcId}
                  onClick={() => handleRemove(conNote)}
                >
                  <ListItemText>{conNote.conNoteNum}</ListItemText>
                  <ListItemText>{conNote.eventType}</ListItemText>
                  <ListItemText>
                    {conNote.eventDateTime.match(/T(\d{2}:\d{2}):/)[1]}
                  </ListItemText>
                  {/* <IconButton name={conNote.conNoteNum} onClick={() => handleRemove(conNote)}>
                    <DeleteForeverIcon />
                  </IconButton> */}
                </ListItem>
              ))}
            </List>
          </Box>
        </Grid>
      </Grid>
    </DialogContent>
  );
}

export default SelectConNote;
